<template>
  <router-view></router-view>
</template>

<script>
import core from "@/core";

export default {
  name: "App",
  mounted() {
    window.showModal = this.showModal;
  },
  methods: {
    showModal: function (params) {
      return core.alert.show(params);
    },
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
